import { render, staticRenderFns } from "./ModalHistoricoPedido.vue?vue&type=template&id=0c2a2416"
import script from "./ModalHistoricoPedido.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoPedido.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoPedido.vue?vue&type=style&index=0&id=0c2a2416&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports